module.exports = __webpack_public_path__ + "static/newtestament-c2c124b31c691d4ab595d5b6dd95458a.jpg";